import { Component, HostBinding, Input } from '@angular/core';

export enum FontType {
  PARAGRAPH = 'paragraph',
  SPAN = 'span',
  STRONG = 'strong',
}

export enum FontSize {
  XSMALL = 'tiny',
  SMALL = 'detail',
  MID = 'ui',
  LARGE = 'landing',
}

export enum FontColor {
  DARK = 'dark',
  MID = 'mid',
  LIGHT = 'light',
  ERROR = 'error',
  SUCCESS = 'success',
  WARNING = 'warning',
}

export enum FontWeight {
  BOLD = 'bold',
  NORMAL = 'normal',
}

export enum FontStyle {
  ITALIC = 'italic',
  NORMAL = 'normal',
}

@Component({
  selector: 'fl-text',
  template: `
    <ng-container [ngSwitch]="fontType">
      <p *ngSwitchCase="FontType.PARAGRAPH"
        [attr.data-color]="color"
        [attr.data-size]="size"
        [attr.data-size-tablet]="sizeTablet"
        [attr.data-size-desktop]="sizeDesktop"
        [attr.data-weight]="weight"
        [attr.data-style]="style"
        [attr.data-word-break]="wordBreak"
      >
        <ng-container *ngTemplateOutlet="injectedContent"></ng-container>
      </p>
      <span *ngSwitchCase="FontType.SPAN"
        [attr.data-color]="color"
        [attr.data-size]="size"
        [attr.data-size-tablet]="sizeTablet"
        [attr.data-size-desktop]="sizeDesktop"
        [attr.data-weight]="weight"
        [attr.data-style]="style"
        [attr.data-word-break]="wordBreak"
      >
        <ng-container *ngTemplateOutlet="injectedContent"></ng-container>
      </span>
      <strong *ngSwitchCase="FontType.STRONG"
        class="Strong"
        [attr.data-size]="size"
        [attr.data-size-tablet]="sizeTablet"
        [attr.data-size-desktop]="sizeDesktop"
        [attr.data-weight]="weight"
        [attr.data-word-break]="wordBreak"
      >
        <ng-container *ngTemplateOutlet="injectedContent"></ng-container>
      </strong>
      <ng-template #injectedContent>
        <ng-content></ng-content>
      </ng-template>
    </ng-container>
`,
  styleUrls: ['./text.component.scss'],
})
export class TextComponent {
  FontType = FontType;

  @Input() color = FontColor.DARK;

  /** Font size for mobile and above */
  @Input() size = FontSize.MID;

  /** Change the [size] from tablet and above */
  @Input() sizeTablet?: FontSize;

  /** Change the [size] and/or [sizeTablet] from desktop and above */
  @Input() sizeDesktop?: FontSize;

  @Input() style = FontStyle.NORMAL;

  @Input() weight = FontWeight.NORMAL;

  /** Forcefully breaks overflowing content, useful for long urls */
  @Input() wordBreak = false;

  /** Defines the HTML node it will use e.g (<p>, <span>, <strong>)
   *  Note: This is for semantics usage which defaults to a <p> tag
   */
  @HostBinding('attr.data-type')
  @Input()
  fontType = FontType.PARAGRAPH;
}
